module.exports = __webpack_public_path__ + "img/intelectual.07f82fa6.png";